import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import {
  FaTachometerAlt,
  FaPrayingHands,
  FaCalendarCheck,
  FaBook,
  FaDonate,
  FaImages,
  FaCalendarAlt,
  FaBars,
  FaTimes,
  FaSignOutAlt,
  FaUser,
  FaUsers,
} from 'react-icons/fa';
import './AdminSidenav.css';

interface NavItem {
  label: string;
  to: string;
  icon: React.ReactNode;
  badge?: number;
}

const navItems: NavItem[] = [
  { label: 'Dashboard', to: '/admin', icon: <FaTachometerAlt /> },
  { label: 'Mass Intentions', to: '/admin/mass-intentions', icon: <FaPrayingHands /> },
  { label: 'Pilgrimage Bookings', to: '/admin/pilgrimage-bookings', icon: <FaCalendarCheck /> },
  { label: 'Blogs', to: '/admin/blogs', icon: <FaBook /> },
  { label: 'Blog Categories', to: '/admin/blog-categories', icon: <FaBook /> },
  { label: 'Donations', to: '/admin/donations', icon: <FaDonate /> },
  { label: 'Gallery', to: '/admin/gallery', icon: <FaImages /> },
  { label: 'Events', to: '/admin/events', icon: <FaCalendarAlt /> },
  { label: 'Projects', to: '/admin/projects', icon: <FaCalendarAlt /> },
  { label: 'Users', to: '/admin/users', icon: <FaUsers /> },
  { label: 'Profile', to: '/admin/profile', icon: <FaUser /> },
];

export const AdminSidenav: React.FC = () => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout().then(() => navigate('/admin/login', { replace: true }));
  };

  const toggleMobileMenu = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileOpen(false);
  };

  return (
    <>
      {/* Mobile Menu Toggle */}
      <button
        className="admin-sidenav__mobile-toggle"
        onClick={toggleMobileMenu}
        aria-label="Toggle menu"
        aria-expanded={isMobileOpen}
      >
        {isMobileOpen ? <FaTimes /> : <FaBars />}
      </button>

      {/* Backdrop */}
      {isMobileOpen && (
        <div
          className="admin-sidenav__backdrop"
          onClick={closeMobileMenu}
          aria-hidden="true"
        />
      )}

      {/* Sidebar */}
      <aside className={`admin-sidenav ${isMobileOpen ? 'admin-sidenav--open' : ''}`}>
        <div className="admin-sidenav__header">
          <div className="admin-sidenav__logo">
            <img src="/CONVKENYA_Transparent.png" alt="Kenya Friars" />
          </div>
        </div>

        <nav className="admin-sidenav__nav">
          <ul className="admin-sidenav__menu">
            {navItems.map((item) => {
              return (
                <li key={item.to} className="admin-sidenav__menu-item">
                  <NavLink
                    to={item.to}
                    end={item.to === '/admin'}
                    className={({ isActive }) =>
                      `admin-sidenav__link ${isActive ? 'admin-sidenav__link--active' : ''}`
                    }
                    onClick={closeMobileMenu}
                  >
                    <span className="admin-sidenav__link-icon">{item.icon}</span>
                    <span className="admin-sidenav__link-text">{item.label}</span>
                    {item.badge && item.badge > 0 && (
                      <span className="admin-sidenav__badge">{item.badge}</span>
                    )}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>

        <div className="admin-sidenav__footer">
          <button className="admin-sidenav__logout" onClick={handleLogout}>
            <FaSignOutAlt />
            <span>Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
};
